import { Link, useLocation } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useCompany } from '../hooks/useCompany';
import { useAuthStore } from '../stores/auth.store';
import { canCompleteCompanyRegistration } from '../lib/roles';

/**
 * PendingKybBanner — firma kaydı (KYB) tamamlanmadıysa (status PENDING_KYB)
 * dashboard'un üstünde kalıcı uyarı şeridi.
 *
 * CTA role-aware: yalnızca kaydı tamamlayabilen rol (OWNER/CEO/CFO) "Firma Kaydı"
 * butonunu görür — bu roller dışında `/firma-kaydi` route-locked olduğundan buton
 * dead-link olurdu; onlara sadece bilgilendirici metin gösterilir.
 * Zaten /firma-kaydi sayfasındaysak gösterme (gereksiz tekrar).
 */
export function PendingKybBanner() {
  const { data } = useCompany();
  const role = useAuthStore((s) => s.user?.role ?? null);
  const location = useLocation();

  if (data?.status !== 'PENDING_KYB') return null;
  if (location.pathname === '/firma-kaydi') return null;

  const canComplete = canCompleteCompanyRegistration(role);

  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-3 border-b border-custel-warning/30 bg-custel-warning-subtle px-4 py-2.5 text-sm text-custel-warning-fg md:px-6"
    >
      <span className="flex items-center gap-2">
        <AlertTriangle size={16} aria-hidden="true" className="shrink-0" />
        <span className="font-medium">
          {canComplete
            ? 'Lütfen Firma Kaydınızı Tamamlayınız'
            : 'Firma kaydınız onay bekliyor. Yöneticiniz firma kaydını tamamlamalı.'}
        </span>
      </span>
      {canComplete && (
        <Link
          to="/firma-kaydi"
          className="shrink-0 rounded-custel-md bg-custel-ink px-3 py-1.5 text-xs font-medium text-custel-krem transition-colors hover:bg-custel-g700 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-custel-ink"
        >
          Firma Kaydı
        </Link>
      )}
    </div>
  );
}
